import { extendTheme } from '@chakra-ui/react'
// import { Global } from '@emotion/react'

const theme = extendTheme({
  fonts: {
    heading: 'Manrope, sans-serif',
    body: 'Manrope, sans-serif',
  },
})

export default theme